module.exports = __webpack_public_path__ + "img/43.e6065d4e.jpg";